module.exports = __webpack_public_path__ + "img/bg.6b20742f.png";